exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/core-js/modules/_wks-ext.js
// module id = 278
// module chunks = 0